<template>
  <tr class="caption">
    <td style="white-space: normal;">
      <template v-if="isCustomRow">
        {{ item.json_data.name }}
      </template>
      <template v-else>
        <div class="font-weight-bold">
          {{ item.definition.name }}
        </div>
        <v-chip x-small v-if="item.definition.sku">
          SKU: {{ item.definition.sku }}
        </v-chip>
      </template>

      <!-- SOMETHING -->
      <v-chip outlined x-small v-for="trueCol in trueCustomColumns" :key="trueCol" color="green">
        {{ trueCol }}
      </v-chip>
    </td>
    <td>
      <c-ms-ii
      v-if="item.quantity"
      :metric_definition="item.definition" 
      :realValue="item.quantity"
      :key="'c' + (item.definition || {}).id"
      :metric.sync="currentMetric"
      labelMode
      ></c-ms-ii>
    </td>
    <td>
      <c-ms-ii
      v-if="item.weight"
      sid="si-mass-g"
      :realValue="item.weight"
      labelMode
      ></c-ms-ii>
    </td>
    <td>
      <c-cost-per-unit 
      v-if="item.cost_per_unit"
      :realCost="costPerUnit"
      :definition="item.definition"
      :metric.sync="currentMetric"
      :currencyLabel="currencyLabel"
      labelMode>
      </c-cost-per-unit>
    </td>
    <td>
      <c-price 
      v-if="item.total_cost"
      :quantity="totalCost" 
      :currency="currency" 
      labelMode>
      </c-price>
    </td>
    <td>
      <template v-if="item.discount">
        {{ item.discount }}
      </template>
    </td>
    <td class="text-end">
      <c-price :quantity="automaticTotalCostMinusDiscount" labelMode :currency="currency">
      </c-price>
    </td>
  </tr>
</template>

<script>
import {BigNumber} from 'bignumber.js'

export default {
  props: {
    item: null,
    currency: null,
    rateMultiplier: null
  },
  data () {
    return {
      currentMetric: 0,
    }
  },
  computed: {
    trueCustomColumns () {
      var arr = []
      if (this.item.custom_columns) {
        for (var key of Object.keys(this.item.custom_columns)) {
          if (this.item.custom_columns[key] === true) {
            arr.push(key)
          }
        }
      }
      return arr
    },
    totalCost () {
      return this.item.total_cost * this.rateMultiplier
    },
    costPerUnit () {
      return this.item.cost_per_unit * this.rateMultiplier
    },
    isCustomRow () {
      if (this.item.json_data) {
        return true
      }
      return false
    },
    currencyLabel () {
      return (this.$store.state.db.currencies.items[this.currency] || {}).symbol
    },
    quantityInUnits () {
      switch (this.currentMetric) {
        case 0:
          return this.item.quantity
        case 1:
          // ml - litres
          return new BigNumber(this.item.quantity).dividedBy(1000)
        case 2:
          // mg - kg
          return new BigNumber(this.item.quantity).dividedBy(1000 * 1000)
        case 3:
          // mm - m
          return new BigNumber(this.item.quantity).dividedBy(1000)
      }
    },
    automaticTotalCost () {
      return new BigNumber(this.quantityInUnits).times(this.costPerUnit).toNumber()
    },
    automaticTotalCostMinusDiscount () {
      var discount = new BigNumber(100 - this.item.discount).dividedBy(100)
      return new BigNumber(this.totalCost).times(discount).toNumber()
    }
  }
}
</script>

